import React from 'react';

// Components.
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

// Font Awesome icons.
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SFB_Logo from '../images/SFB_Logo.png'

export default function AlertModal({ alertConfig = {}, children, confirmButtonProps = {}, handleOnConfirm = () => null, handleCloseOnClick = () => null }) {
  const { isOpen = false, message = '', isConfirm = false } = alertConfig;
  const { textValue: confirmTextValue, ...confirmButtonDomProps } = confirmButtonProps;
  const modalTitleId = 'alert-modal-title';

  return(
    <Modal
      backdrop
      size="lg"
      isOpen={isOpen}
      labelledBy={modalTitleId}
      aria-modal="true"
      contentClassName="bg-darker rounded-4 shadow"
    >
      <div className="d-flex justify-content-between align-items-center px-3 py-2 z-1 border-0 border-bottom border-primary-orange-subtle modal-header rounded-top-4 surface-elevated" >
        <div className="modal-brand-slot">
            <img fetchpriority="high" src={SFB_Logo} alt="Spitface Battles Logo" width="48" height="48" loading="lazy" decoding="async" className="img-fluid rounded-circle shadow-xs" />
        </div>
        
        <h1 id={modalTitleId} className={`text-center fs-3 m-0 ${'headerLabelClassName'}`}>
            <div className="lh-tight text-uppercase mb-0 site-title anton-regular fw-normal">
                <span className="text-primary-orange">Spitface</span>
                <span className="fs-6 text-white">Battles</span>
            </div>
        </h1>

        <Button outline color="transparent" aria-label="Close dialog" onClick={handleCloseOnClick} className="border-0 p-1">
            <FontAwesomeIcon icon={faTimes} size="2x" className="text-danger" />
        </Button>
    </div>

      <ModalBody role="alert" aria-live="assertive" className="d-flex flex-column justify-content-around gap-2 p-4 bg-darker alert-body text-secondary">
        {message && typeof message === 'string' ? (
          message.split('\n').map((textLine, index) => (
            <p
              key={textLine + index}
              className={`m-0 ${textLine.includes('WARNING') ? 'small text-center text-danger' : ''} ${textLine.includes('INFO') ? 'small text-center text-info' : ''}`}
            >
              {textLine}
            </p>
          ))
        ) : (
          <>
            {message && JSON.stringify(message)}
          </>
        )}

        {children}
      </ModalBody>

      <ModalFooter className="px-3 rounded-bottom-4 border-0 border-top border-primary-orange-subtle gap-2 justify-content-end surface-elevated">
        <Button
          outline
          size="md"
          id="close"
          onClick={handleCloseOnClick}
          className={`m-0 px-4 fw-semibold border-2 ${isConfirm ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
        >
          {isConfirm ? 'Cancel' : 'Dismiss'}
        </Button>
        {isConfirm && (
          <Button
            color="primary"
            size="sm"
            id="confirm"
            onClick={handleOnConfirm}
            {...confirmButtonDomProps}
            className="fw-semibold px-4 text-uppercase"
          >
            {confirmTextValue ?? 'Confirm'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}
